export const ZOOM_LEVELS = [0.25, 0.4, 0.5, 0.6, 0.75, 1];
export const DEFAULT_ZOOM = "fit";

export const LAYOUT_MODES = {
  GRID: "grid",
  LIST: "list",
  COMPACT: "compact",
};

export const SORT_MODES = {
  DEFAULT: "default",
  WIDTH: "width",
  CATEGORY: "category",
  BRAND: "brand",
  NAME: "name",
};

export const CATEGORY_LABELS = {
  phone: "Phones",
  tablet: "Tablets",
  laptop: "Laptops",
  desktop: "Desktops",
  custom: "Custom",
};

export const MAX_HISTORY_ITEMS = 5;
export const MAX_SESSIONS = 20;

// How long we wait before assuming an iframe failed to load / is blocked
// by X-Frame-Options or a frame-ancestors CSP. Browsers give us no reliable
// signal for this, so a timeout plus honest wording is the best we can do.
export const IFRAME_LOAD_TIMEOUT_MS = 9000;

// Display cap (px) for a "fit" scaled frame's height. Without this, a tall
// portrait tablet (e.g. 1024x1366) scaled purely to fit the available
// width would render far taller than the workspace, crowding the row
// below it. Width still comes from the live container via ResizeObserver.
export const MAX_FIT_FRAME_HEIGHT = 620;

export const SESSION_SCHEMA_VERSION = 1;
